// Guide管理
import http from "@/jslibs/axios/http";

// 新增Guide
export const add = (data) => http.post("/cms/guide/add", data);

// 编辑Guide
export const edit = (data) => http.post("/cms/guide/update", data);

// Guide详情
export const detail = (id) => http.get("/cms/guide/details/" + id);

// Guide分页列表
export const page = (data) => http.get("/cms/guide/page", data);

// Guide删除
export const del = (id) => http.delete("/cms/guide/" + id);